<template>
  <div>
    <div class="commonBg contactBg">
      <img :src="$imgUrl.imgUrl(banner.pic)" alt="" />
      <!-- <div class="title">
        <span>{{ banner.title }}</span>
      </div> -->
    </div>
    <div class="contactBox">
      <div class="contactLocation">
        <div class="commonTitle">
          <div class="text1">联系我们</div>
          <div class="text2">Contact Us</div>
        </div>
        <div class="contactMsgs">
          <div
            class="contactMsg"
            v-for="(item, index) in contactMsgList"
            :key="index"
          >
            <div class="text1 text">{{ item.key }}</div>
            <div class="text2 text">{{ item.value }}</div>
          </div>
        </div>
        <div class="contactMsgs" v-if="isEn">
            <div
              class="contactMsg"
              v-for="(item, index) in managerList"
              :key="index"
            >
              <div class="contactMsgFlex">
                <div class="text1 text">Name:</div>
                <div class="text2 text">{{ item.name }}</div>
              </div>
              <div class="contactMsgFlex">
                <div class="text1 text">Position:</div>
                <div class="text2 text">{{ item.position }}</div>
              </div>
              <div class="contactMsgFlex">
                <div class="text1 text">Tel:</div>
                <div class="text2 text">{{ item.phone }}</div>
              </div>
              <div class="contactMsgFlex">
                <div class="text1 text">E-mail:</div>
                <div class="text2 text">{{ item.mail }}</div>
              </div>
            </div>
          </div>
        <div class="commonTitle marginTop60" v-if="isEn">
          <div class="text1">Fill In Your Information</div>
        </div>
        <div class="JoinUsForm" v-if="isEn">
          <div class="formsContent">
            <el-form
              :model="formSoftware"
              ref="formSoftware"
              label-width="100px"
            >
              <el-form-item prop="company">
                <span slot="label">
                  <span>Company</span>
                </span>
                <el-input
                  v-model="formSoftware.company"
                  placeholder="Company"
                ></el-input>
              </el-form-item>
              <el-form-item prop="phone">
                <span slot="label">
                  <span> Telephone:</span>
                </span>
                <el-input
                  v-model="formSoftware.phone"
                  placeholder="Telephone"
                ></el-input>
              </el-form-item>
              <el-form-item prop="name">
                <span slot="label">
                  <span>Name</span>
                </span>
                <el-input
                  v-model="formSoftware.name"
                  placeholder="Name"
                ></el-input>
              </el-form-item>
              <el-form-item prop="email">
                <span slot="label">
                  <span> Email</span>
                </span>
                <el-input
                  v-model="formSoftware.email"
                  placeholder="Email"
                ></el-input>
              </el-form-item>
              <el-form-item label="Message" prop="remark" class="descrBox">
                <el-input
                  type="textarea"
                  v-model="formSoftware.remark"
                  placeholder="Message"
                ></el-input>
              </el-form-item>
              <el-form-item class="clickBtn">
                <el-button class="btn" @click="submitForm()"
                  >SUBMIT</el-button
                >
              </el-form-item>
            </el-form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<style scoped>
.contactBox{
  padding-top: 120px;
}
.marginTop60{
  margin-top:60px;
}
.contactLocation{
  padding-bottom: 80px;
}
.commonBg {
  max-height: 520px;
}
.commonBg img {
  height: 520px;
}

.commonTitle {
  width: 100%;
  font-size: 36px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #009144;
  line-height: 42px;
  text-align: left;
  font-style:initial;
}

.commonTitle .text2 {
  font-size: 16px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #999999;
  line-height: 42px;
}
.contactMsgs {
  width: 75vw;
  padding: 10px 0 60px 0;
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}
.contactMsg {
  width: 31.2vw;
  padding: 26px 0 40px 0;
  box-sizing: border-box;
  border-bottom: 1px solid #d9d9d9;
  flex-shrink: 0;
}
.contactMsgFlex{
  display: flex;
}
.contactMsgFlex .text1{
  width: 110px;
}
.contactMsg .text {
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #666666;
  line-height: 42px;
}
.contactMsg .text1 {
  font-size: 20px;
}
.contactMsg .text2 {
  font-size: 16px;
}
.contactMsg:not(:nth-child(2n)) {
  margin-right: 12.5vw;
}
/* 表单样式 */
.JoinUsForm {
  width: 100%;
  background: #ffffff;
  padding: 0 4vw;
  box-sizing: border-box;
}
.formsContent {
  background: #ffffff;
  width: 100%;
  padding-top:48px;
  padding-bottom: 0;
}
.el-form {
  width: 100%;

  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
}
/deep/.el-form .el-input__inner {
  width: 23vw !important;
}
/deep/.el-form-item:not(:nth-child(2n)) {
  margin-right: 3.7vw;
}
/deep/.el-textarea__inner {
  width: 55vw;
  height: 100px;
}
.descrBox {
  margin-right: 0px !important;
  flex-shrink: 0;
}

.red {
  color: #fc2f2f;
}
.btn {
  width: 160px;
  margin-top: 30px;
  background: #009144;
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #fefefe;
  line-height: 42px;
}
/deep/.clickBtn .el-form-item__content {
  margin-left: 0 !important;
}
</style>
<script>
import cheader from "../../src/components/header";
import cfooter from "../../src/components/footer";
import * as axios from "../../src/axios/api.js";
import imgUrl from "../../src/utils/imgUrl.js";
export default {
  data() {
    return {
      banner: {},
      contact: [],
      contactMsgList: [
      ],
      managerList:[],
      isEn:false,
      formSoftware: {
        name: "",
        phone: "",
        company: "",
        email: "",
        remark: "",
      },
    };
  },
  created() {
    let catid = this.$route.query.id;
    this.getContactList(catid);
  },
  mounted() {
    // alert(1)
  },
  methods: {
    getContactList(catid) {
      axios.get("/api/about",{catid:catid}).then((res) => {
        if (res.code == 1) {
          this.banner = res.data.banner[0];
          this.contactMsgList=res.data.contact;
          this.managerList=res.data.info.custom;
        }
      });
    },
    submitForm(){
      axios.post("/api/message/contact",this.formSoftware).then((res) => {
        if (res.code == 1) {
          this.$message({
            message: res.msg,
            type: "success",
          });
          this.formSoftware=[];
        }
      });
      
    }
  },
};
</script>